import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CustomersRoute } from "./CustomersRoute";
import CustomersRouteQueryNode, {
  type CustomersRouteQuery$variables,
} from "./__generated__/CustomersRouteQuery.graphql";

function isArchivedParam(urlSearchParams: URLSearchParams): boolean {
  const param = urlSearchParams.get("archived");
  return param !== null && param !== undefined && param !== "false";
}

const entryPoint: SimpleEntryPoint<typeof CustomersRoute> = {
  root: JSResource("CustomersRoute", () =>
    import("./CustomersRoute").then((module) => module.CustomersRoute),
  ),
  getPreloadProps({ request }) {
    const url = new URL(request.url);
    const variables: CustomersRouteQuery$variables = {
      onlyArchived: isArchivedParam(url.searchParams),
    };

    return {
      queries: {
        query: {
          parameters: CustomersRouteQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
